import Role from "../../lib/Role";


/**
 * @return {boolean}
 */
function CanEditGroup(loggedInUser) {
    return loggedInUser.role === Role.ADMIN;
}
export default CanEditGroup;